<div class="contractor-types-page" [class.modal-open]="isChildRouteActive">
  <div class="grey-container" [class.modal-open]="isChildRouteActive">
    <div class="container-header modal-anchor">
      <a
        *ngIf="isGlobalAdmin"
        class="add-link"
        style="margin-right: 16px;"
        [class.disabled]="isChildRouteActive"
        (click)="openImportDialog()"
      >
        Import Contractor Type
      </a>
      <a
        class="add-link"
        [class.disabled]="isChildRouteActive"
        (click)="onCreateNew()"
      >
        Add New Contractor Type
      </a>
    </div>

    <div class="skeleton-wrapper" [hidden]="!isLoading">
      <div class="type-card skeleton" *ngFor="let i of [1, 2, 3, 4]">
        <div class="type-content">
          <div class="text-group">
            <div class="skeleton-bar title"></div>
            <div class="skeleton-bar subtitle"></div>
          </div>

          <div class="type-actions">
            <div class="skeleton-split">
              <div class="skeleton-btn main"></div>
              <div class="skeleton-btn caret"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-state-container error" [hidden]="!hasError || isLoading">
      <wm-common-icon [data]="{ iconName: 'report_problem' }"></wm-common-icon>
      <p>{{ errorMessage }}</p>
      <button class="retry-btn" (click)="loadContractorTypes()">Retry</button>
    </div>

    <div class="types-list" [hidden]="isLoading || hasError">
      <div class="list-state-container" [hidden]="contractorTypes?.length > 0">
        <p>No contractor types found.</p>
      </div>

      <div
        class="type-card"
        *ngFor="let type of contractorTypes"
        [attr.data-ct-id]="type.id"
      >
        <div class="type-content">
          <div class="text-group" (click)="toggleExpand(type.id)">
            <span class="type-name">
              {{ type.name }}
            </span>

            <span
              class="publish-date d-flex align-items-center"
              style="gap: 12px;"
            >
              <ng-container *ngIf="type.lastPublishedOn; else neverPub">
                <span>
                  <span class="last-published-label">Last Published On:</span>
                  {{ type.lastPublishedOn | date: 'MM/dd/yyyy hh:mm a' }}
                </span>
              </ng-container>

              <ng-template #neverPub>
                <span class="badge badge-pill badge-warning mb-0">
                  Never published
                </span>
              </ng-template>

              <span
                *ngIf="type.lastPublishedOn && hasChangesAvailable(type)"
                class="badge badge-pill badge-success mb-0"
              >
                Changes available
              </span>
            </span>
          </div>

          <div class="type-actions" (click)="$event.stopPropagation()">
            <button
              type="button"
              class="icon-action-btn"
              [disabled]="!canManageContractors"
              (click)="toggleMenu(type.id, $event)"
              title="More actions"
            >
              <wm-common-icon [data]="{ iconName: 'build' }"></wm-common-icon>
            </button>

            <button
              type="button"
              class="icon-action-btn"
              [disabled]="!canManageContractors"
              (click)="onEdit(type, $event)"
              title="Edit contractor type"
            >
              <wm-common-icon [data]="{ iconName: 'edit' }"></wm-common-icon>
            </button>

            <button
              type="button"
              class="icon-action-btn danger"
              [disabled]="!canDelete(type)"
              (click)="openTypeActionModal(type, 'delete')"
              title="Delete contractor type"
            >
              <wm-common-icon [data]="{ iconName: 'delete' }"></wm-common-icon>
            </button>

            <button
              type="button"
              class="icon-action-btn expand-btn"
              (click)="toggleExpand(type.id)"
              title="Expand details"
            >
              <wm-common-icon
                [data]="{
                  iconName:
                    expandedId === type.id ? 'expand_less' : 'expand_more'
                }"
              >
              </wm-common-icon>
            </button>

            <div class="icon-menu" *ngIf="isMenuOpen(type.id)">
              <button
                type="button"
                class="menu-item"
                [class.disabled]="!canPublish(type)"
                [disabled]="!canPublish(type)"
                (click)="openTypeActionModal(type, 'publish'); closeMenu()"
              >
                {{ canPublish(type) ? 'Publish' : 'Published' }}
              </button>

              <button
                type="button"
                class="menu-item"
                *ngIf="canManageContractors"
                (click)="openTypeActionModal(type, 'copy'); closeMenu()"
              >
                Copy
              </button>

              <div class="menu-divider"></div>

              <button
                type="button"
                class="menu-item"
                *ngIf="canViewHistory()"
                (click)="
                  openWorkflowHistory(
                    type.registerWorkflowId,
                    type.name + ' - Register'
                  );
                  closeMenu()
                "
              >
                Register Workflow History
              </button>
              <button
                type="button"
                class="menu-item"
                [class.disabled]="!isPublished(type)"
                [disabled]="!isPublished(type)"
                (click)="
                  openPublishHistory(
                    type.registerWorkflowId,
                    type.name + ' - Register'
                  );
                  closeMenu()
                "
              >
                Publish Register Workflow History
              </button>
              <a
                class="menu-item"
                *ngIf="canManageContractors"
                [routerLink]="[
                  '/admin/workflow-builder',
                  type.registerWorkflowId
                ]"
  (click)="onWorkflowBuilder(type, $event);closeMenu()"
              >
                Register Workflow Builder
              </a>

              <div class="menu-divider"></div>

              <button
                type="button"
                class="menu-item"
                *ngIf="canViewHistory()"
                (click)="
                  openWorkflowHistory(
                    type.renewWorkflowId,
                    type.name + ' - Renewal'
                  );
                  closeMenu()
                "
              >
                Renewal Workflow History
              </button>
              <button
                type="button"
                class="menu-item"
                [class.disabled]="!isPublished(type)"
                [disabled]="!isPublished(type)"
                (click)="
                  openPublishHistory(
                    type.renewWorkflowId,
                    type.name + ' - Renewal'
                  );
                  closeMenu()
                "
              >
                Publish Renewal Workflow History
              </button>
              <a
                class="menu-item link-like"
                *ngIf="canManageContractors"
                [routerLink]="['/admin/workflow-builder', type.renewWorkflowId]"
  (click)="onWorkflowBuilder(type, $event);closeMenu()"
              >
                Renewal Workflow Builder
              </a>
            </div>
          </div>
        </div>

        <div class="details-section" *ngIf="expandedId === type.id">
          <div class="details-content">
            <app-loader *ngIf="isDetailsLoadingMap[type.id]"></app-loader>

            <ng-container
              *ngIf="!isDetailsLoadingMap[type.id] && detailsMap[type.id] as ct"
            >
              <div class="contractor-detail-shell">
                <div
                  class="detail-header-actions detail-header-actions-left"
                  *ngIf="canManageContractors"
                >
                  <button
                    type="button"
                    class="workflow-btn workflow-btn-light"
                    (click)="openBuilder1(ct.registerWorkflowId)"
                  >
                    Register Builder
                  </button>

                  <button
                    type="button"
                    class="workflow-btn workflow-btn-primary"
                    (click)="openBuilder2(ct.renewWorkflowId)"
                  >
                    Renew Builder
                  </button>

                  <button
                    *ngIf="isGlobalAdmin"
                    type="button"
                    class="workflow-btn workflow-btn-light"
                    (click)="exportContractorType(ct)"
                    title="Export this contractor type to a JSON file for import into another environment"
                  >
                    Export
                  </button>
                </div>

                <p class="detail-description">
                  {{
                    ct.description || 'No description available for this type.'
                  }}
                </p>

                <div class="detail-summary-card">
                  <div class="detail-summary-grid">
                    <div class="summary-item">
                      <div class="summary-label">Registration Fee</div>
                      <div class="summary-value">
                        {{ ct.registrationFee || '$0.00' }}
                      </div>
                    </div>

                    <div class="summary-item">
                      <div class="summary-label">Renewal Fee</div>
                      <div class="summary-value">
                        {{ ct.renewalFee || '$0.00' }}
                      </div>
                    </div>

                    <div class="summary-item summary-item-wide">
                      <div class="summary-label">Last Published On</div>

                      <div
                        class="summary-value"
                        *ngIf="
                          ct.registerWorkflow?.lastPublishedOn;
                          else neverPublishedBlock
                        "
                      >
                        {{ ct.registerWorkflow.lastPublishedOnString }} by
                        {{ ct.registerWorkflow.lastPublishedBy }}
                      </div>

                      <ng-template #neverPublishedBlock>
                        <span class="badge badge-pill badge-warning">
                          Never published
                        </span>
                      </ng-template>

                      <span
                        *ngIf="
                          ct.registerWorkflow?.lastPublishedOn &&
                          (ct.registerWorkflow?.areThereChangesNotPublished ||
                            ct.renewWorkflow?.areThereChangesNotPublished)
                        "
                        class="badge badge-pill badge-success detail-change-badge"
                      >
                        Changes available
                      </span>
                    </div>
                  </div>
                </div>

                <div class="contractor-grid-header d-flex justify-content-between align-items-center mb-2">
                  <h4 class="mb-0">Contractors</h4>

                  <app-reports-table-header
                    [id]="'contractor-registrations-' + type.id"
                    [title]="type.name + ' Contractors'"
                    [params]="contractorFilterParams"
                    [currentFilters]="activeFiltersMap[type.id]"
                    [currentColumnOptions]="contractorExportColumns"
                    [isEditorVisible]="isEditorVisibleMap[type.id]"
                    (exportExcel)="handleExcelExport(type)"
                    (exportCsv)="handleCsvExport(type)"
                    (showScheduledExportsEditorChange)="
                      handleEditorVisibility(type.id, $event)
                    "
                  >
                  </app-reports-table-header>
                </div>

                <div class="w-100 mb-3">
                  <wm-filter-builder
                    [id]="'contractor-type-' + type.id"
                    [parentId]="'grid-' + type.id"
                    [staffFilterBuilder]="true"
                    [showExportOption]="true"
                    [filterTypes]="filterTypes"
                    [contractorTypeColumnsPopup]="true"
                    [savedFilters]="true"
                    [showSimpleSearch]="false"
                    [params]="contractorFilterParams"
                    [columnOptions]="contractorExportColumns"
                    [onlyExportOptions]="false"
                    (filtersChange)="handleGridFiltersChange(type.id, $event)"
                    (columnsChange)="handleGridColumnsChange(type.id, $event)"
                  >
                  </wm-filter-builder>
                </div>

                <wm-common-table
                  #regTable
                  tableType="Staff"
                  [columns]="getContractorColumns(type, regTable)"
                  [data]="currentRegistrations"
                  [isLoading]="isTableLoading"
                  [errorMessage]="tableErrorMessage"
                  [serverSidePagination]="true"
                  [currentPage]="currentPage"
                  [totalPages]="totalPages"
                  [pageSize]="pageSize"
                  [showRowsPerPage]="true"
                  [defaultPageSize]="pageSize"
                  expansionMode="inline"
                  [expandedComponent]="expandedComponent"
                  [expandedComponentInputs]="expandedComponentInputs"
                  (sortChanged)="onRegistrationsSortChanged(type.id, $event)"
                  (rowsPerPageChange)="
                    onRegistrationsRowsPerPageChange(type.id, $event)
                  "
                  (pageChange)="onRegistrationsPageChange(type.id, $event)"
                >
                </wm-common-table>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <wm-common-overlay-modal
    class="contractor-settings-overlay"
      [isOpen]="isHistoryModalOpen"
      [offsetTop]="overlayOffsetTop"
      [headerTitle]="historyModalTitle"
      maxWidth="97%"
      (closed)="closeHistoryModal()"
    >
      <div class="history-scroll-container">
        <wm-workflow-checkpoint-list
          [checkpoints]="checkpoints"
          [workflowId]="selectedWorkflowId"
          (onRestore)="restoreCheckpoint($event)"
        >
        </wm-workflow-checkpoint-list>
        <div modal-footer>
          <button
            class="workflow-btn workflow-btn-light"
            (click)="closeHistoryModal()"
          >
            CANCEL
          </button>
        </div>
      </div>
    </wm-common-overlay-modal>

    <wm-common-overlay-modal
    class="contractor-settings-overlay"
      [isOpen]="isTypeActionModalOpen"
      [offsetTop]="overlayOffsetTop"
      [headerTitle]="typeActionModalTitle"
      maxWidth="97%"
      (closed)="closeTypeActionModal()"
    >
      <ng-container *ngIf="selectedType && currentTypeAction === 'publish'">
        <div *ngIf="isValidatingMap[selectedType.id]" class="text-danger mb-2">
          Validating workflows...
        </div>
        <div
          *ngIf="
            !isValidatingMap[selectedType.id] &&
            getPublishForm(selectedType).controls['isWorkflowValid'].invalid
          "
          class="text-danger mb-2"
        >
          Contractor type has errors, please review the errors in the Contractor
          Type Editor.
        </div>
        <div
          *ngIf="
            !isValidatingMap[selectedType.id] &&
            !getPublishForm(selectedType).controls['isWorkflowValid'].invalid
          "
          class="text-success mb-2"
        >
          Contractor Type is valid
        </div>

        <div
          class="form-group text-left w-100"
          [formGroup]="getPublishForm(selectedType)"
        >
          <label class="control-label">
            Reason <span class="text-danger">*</span>
          </label>
          <textarea class="form-control" formControlName="reason"></textarea>
          <wm-control-message
            [control]="getPublishForm(selectedType).controls['reason']"
          ></wm-control-message>
        </div>

        <p class="text-left w-100">
          Are you sure you want to publish the pending changes to the
          Registration and Renewal Workflow for contractor type ({{
            selectedType.name
          }})?
        </p>
        <p class="text-left w-100 mb-1">Some things to take note of.</p>
        <ul class="text-left w-100">
          <li>
            All new contractor registrations for this type will use the new
            workflow.
          </li>
          <li>Any existing applications will not use these changes.</li>
          <ng-container
            *ngIf="
              (customFieldMigrationQueueItemsMap[selectedType.id] || [])
                .length > 0
            "
          >
            <li>
              <wm-move-custom-field-info
                [hasContractorToRegistrationMove]="
                  hasContractorToRegistrationMoveMap[selectedType.id]
                "
                [hasRegistrationToContractorMove]="
                  hasRegistrationToContractorMoveMap[selectedType.id]
                "
              >
              </wm-move-custom-field-info>
            </li>
          </ng-container>
        </ul>
      </ng-container>

      <ng-container *ngIf="selectedType && currentTypeAction === 'delete'">
        <p class="text-left w-100">
          Are you sure you want to delete this contractor type (<b>{{
            selectedType.name
          }}</b
          >)?
        </p>
        <p class="text-left w-100 mb-1">Some things to take note of.</p>
        <ul class="text-left w-100">
          <li>
            Applications will no longer be able to be completed for this
            workflow.
          </li>
          <li>This workflow will still be visible for editing.</li>
        </ul>
      </ng-container>

      <ng-container
        *ngIf="selectedType && currentTypeAction === 'copy'"
      >
        <wm-common-text
          [data]="{ text: 'Copy Contractor Type' }"
          class="copy-contractor-header"
        ></wm-common-text>
        <form
          class="w-100 text-left form-content"
          [formGroup]="getCopyForm(selectedType)"
        >
          <div class="form-group form-data">
            <wm-common-text
              [data]="{ text: 'Jurisdiction' }"
              class="header"
            ></wm-common-text>

            <wm-common-dropdown
              class="target-client-dropdown"
              *ngIf="clients.length > 1"
              formControlName="targetClientId"
              [data]="{
                options: clientOptions
              }"
            >
            </wm-common-dropdown>
          </div>
          <div class="form-group form-data">
            <wm-common-text
              [data]="{ text: 'Copy of “Name here”' }"
              class="header"
            ></wm-common-text>
            <wm-common-textfield
              formControlName="targetName"
              name="inputTargetName"
              [data]="{
                label: ''
              }"
            >
            </wm-common-textfield>
          </div>
        </form>
      </ng-container>

      <div modal-footer>
        <button
          class="workflow-btn workflow-btn-light"
          (click)="closeTypeActionModal()"
        >
          CANCEL
        </button>
        <button
          class="workflow-btn workflow-btn-primary"
          (click)="confirmTypeAction()"
        >
          {{
            currentTypeAction === 'publish'
              ? 'PUBLISH'
              : currentTypeAction === 'delete'
              ? 'DELETE'
              : 'COPY'
          }}
        </button>
      </div>
    </wm-common-overlay-modal>

    <!--- added by furkan for Custom overlay for isRegistrationActionModalOpen --->
    <wm-common-overlay-modal
      [isOpen]="isRegistrationActionModalOpen"
      [offsetTop]="overlayOffsetTop"
      [headerTitle]="registrationModalTitle"
      maxWidth="1200px"
      minHeight="320px"
      (closed)="!registrationModalIsSuccess ? cancelAction() : closeModal()"
    >
      <div class="registration-modal-content">
        <h2 class="modal-main-title" *ngIf="!registrationModalIsSuccess">
          {{ registrationModalTitle }}
        </h2>

        <h2 class="modal-main-title" *ngIf="registrationModalIsSuccess">
          Success
        </h2>

        <div class="modal-desc-content">
          <p>{{ registrationModalDesc }}</p>
        </div>
      </div>

      <div modal-footer>
        <ng-container *ngIf="!registrationModalIsSuccess">
          <button class="custom-action-btn btn-cancel" (click)="cancelAction()">
            CANCEL
          </button>
          <button
            class="custom-action-btn btn-primary"
            (click)="confirmAction()"
          >
            {{
              currentAction === 'delete'
                ? 'DELETE'
                : currentAction === 'disable'
                ? 'DISABLE'
                : 'ENABLE'
            }}
          </button>
        </ng-container>

        <ng-container *ngIf="registrationModalIsSuccess">
          <button class="custom-action-btn btn-primary" (click)="closeModal()">
            OK
          </button>
        </ng-container>
      </div>
    </wm-common-overlay-modal>
    <!--- ended by furkan for Custom overlay for isRegistrationActionModalOpen --->
    <wm-common-overlay-modal
    class="contractor-settings-overlay"
      [isOpen]="isPublishHistoryModalOpen"
      [offsetTop]="overlayOffsetTop"
      [headerTitle]="publishHistoryModalTitle"
      maxWidth="97%"
      (closed)="closePublishHistoryModal()"
    >
      <wm-workflow-publish-history
        *ngIf="selectedPublishWorkflowId"
        [workflowId]="selectedPublishWorkflowId"
      >
      </wm-workflow-publish-history>
      <div modal-footer>
        <button
          class="workflow-btn workflow-btn-primary"
          (click)="closePublishHistoryModal()"
        >
          CLOSE
        </button>
      </div>
    </wm-common-overlay-modal>
  </div>
  <div [ngClass]="isExportRouteActive ? 'janus-export-overlay' : ''">
    <div
      class="janus-export-backdrop"
      *ngIf="isExportRouteActive"
      (click)="closeExportEditor()"
    ></div>
    <router-outlet></router-outlet>
    <router-outlet name="overlay"></router-outlet>
  </div>
</div>
